import bankScotiabank from '../../banksPNG/bankScotiabank.png';

interface IconProps {
	width?: string;
	height?: string;
	alt?: string;
}
export const BancoScotiabankIcon = ({
	width = '17px',
	height = '17px',
	alt = 'Banco Scotiabank',
}: IconProps) => <img src={bankScotiabank} width={width} height={height} alt={alt} />;
